<template>
    <el-table :data="mytableData" stripe style="width: 100%" v-if="mytableData != null">
        <el-table-column prop="openNum" label="期号" min-width="15%" align="center" header-align="center">
        </el-table-column>
        <el-table-column prop="sumResult" label="值" min-width="10%" align="center" header-align="center">

        </el-table-column>
        <el-table-column label="大"  min-width="10%" align="center" header-align="center">
            <template slot-scope="scope">
                <template v-if="!scope.row.head && isBigNum(scope.row)">
                    <span class="badge blue-info red-info">大</span>
                </template>
                <template v-else-if="scope.row.head">
                        {{ scope.row.bigInterval }}
                </template>
            </template>
        </el-table-column>
        <el-table-column label="小"  min-width="10%" align="center" header-align="center">
            <template slot-scope="scope">
                <template v-if="!scope.row.head && !isBigNum(scope.row)">
                    <span class="badge blue-info">小</span>
                </template>
                <template v-else-if="scope.row.head">
                        {{ scope.row.smallInterval }}
                </template>
                
            </template>
        </el-table-column>
        <el-table-column label="单"  min-width="10%" align="center" header-align="center">
            <template slot-scope="scope">
                <template v-if="!scope.row.head && isOddNumber(scope.row)">
                    <span class="badge blue-info">单</span>
                </template>
                <template v-else-if="scope.row.head">
                        {{ scope.row.oddInterval }}
                </template>
                
            </template>
        </el-table-column>
        <el-table-column label="双"  min-width="10%" align="center" header-align="center">
            <template slot-scope="scope">
                <template v-if="!scope.row.head && !isOddNumber(scope.row)">
                    <span class="badge blue-info  red-info">双</span>
                </template>
                <template v-else-if="scope.row.head">
                        {{ scope.row.evenInterval }}
                </template>
            </template>
        </el-table-column>
        <el-table-column label="大单"  min-width="10%" align="center" header-align="center">
            <template slot-scope="scope">
                <template v-if="!scope.row.head && isOddNumber(scope.row) && isBigNum(scope.row)">
                    <span class="badge blue-info">大单</span>
                </template>
                <template v-else-if="scope.row.head">
                        {{ scope.row.bigOddInterval }}
                </template>
            </template>
        </el-table-column>
        <el-table-column label="大双"  min-width="10%" align="center" header-align="center">
            <template slot-scope="scope">
                <template v-if="!scope.row.head && !isOddNumber(scope.row) && isBigNum(scope.row)">
                    <span class="badge red-info">大双</span>
                </template>
                <template v-else-if="scope.row.head">
                        {{ scope.row.bigEvenInterval }}
                </template>
            </template>
        </el-table-column>
        <el-table-column label="小单"  min-width="10%" align="center" header-align="center">
            <template slot-scope="scope">
                <template v-if="!scope.row.head && isOddNumber(scope.row) && !isBigNum(scope.row)">
                    <span class="badge blue-info">小单</span>
                </template>
                <template v-else-if="scope.row.head">
                        {{ scope.row.smallOddInterval }}
                </template>
            </template>
        </el-table-column> 
        <el-table-column label="小双"  min-width="10%" align="center" header-align="center">
            <template slot-scope="scope">
                <template v-if="!scope.row.head && !isOddNumber(scope.row) && !isBigNum(scope.row)">
                    <span style="border-radius: 20px;" class="badge red-info">小双</span>
                </template>
                <template v-else-if="scope.row.head">
                        {{ scope.row.smallEvenInterval }}
                </template>
            </template>
        </el-table-column>
    </el-table>
</template>
<script>
export default {
    data() {
        return {
            mytableData: []
        }
    },
    props: {
        tableData: {
            type: Array,
            default: null,
            require: true
        }
    },
    created() {
        this.calcInterval()
    },
    methods: {

        getResult(data) {
            let result = 0;
            data.forEach(element => {
                result += element
            });

            return result
        },
        isBigNum(data) {
            if(!data  || !data.sumResult)return false
            if (data.sumResult >= 14) return true
            return false
        },
        isOddNumber(data) {
            if(!data  || !data.sumResult)return false
            if (data.sumResult == 0 || (data.sumResult % 2 == 0)) return false
        
            return true
        },

        calcInterval() {
            let bigInterval = 0
            let smallInterval = 0
            let oddInterval = 0
            let evenInterval = 0
            let bigOddInterval = 0
            let bigEvenInterval = 0

            let smallOddInterval = 0
            let smallEvenInterval = 0

            let findBig = true
            let findsmall = true
            let findodd = true
            let findeven = true
            let findBigOdd = true
            let findBigEven = true
            let findSmallOdd = true
            let findSmallEven = true
            this.tableData.forEach(item=>{
                if(item.sumResult){
                    this.mytableData.push(item)
                }
            })
            for (let i = 0; i < this.mytableData.length; i++) {
                let item = this.mytableData[i]
                console.log(item)
                if (item.sumResult) {
                    console.log(item.sumResult)
                    console.log(this.isBigNum(item))
                    if (!this.isBigNum(item) && findBig) {
                        bigInterval++
                    } else {
                        findBig = false
                    }
                    if (this.isBigNum(item) && findsmall) {
                        smallInterval++
                    } else {
                        findsmall = false
                    }
                    if (!this.isOddNumber(item) && findodd) {
                        oddInterval++
                    } else {
                        findodd = false
                    }
                    if (this.isOddNumber(item) && findeven) {
                        evenInterval++
                    } else {
                        findeven = false
                    }
                    if ((!this.isBigNum(item) || !this.isOddNumber(item)) && findBigOdd) {
                        bigOddInterval++
                    } else {
                        findBigOdd = false
                    }
                    if ((!this.isBigNum(item) || this.isOddNumber(item)) && findBigEven) {
                        bigEvenInterval++
                    } else {
                        findBigEven = false
                    }
                    if ((this.isBigNum(item) || !this.isOddNumber(item)) && findSmallOdd) {
                        smallOddInterval++
                    } else {
                        findSmallOdd = false
                    }
                    if ((this.isBigNum(item) || this.isOddNumber(item)) && findSmallEven) {
                        smallEvenInterval++
                    } else {
                        findSmallEven = false
                    }
                    if (!findBig && !findsmall && !findodd && !findeven && !findBigOdd && !findBigEven && !findSmallOdd && !findSmallEven) {
                        break
                    }

                }
            }
            this.mytableData.unshift({
                head: true,
                openNum: "间隔",
                sumResult: "",
                bigInterval: bigInterval,
                smallInterval: smallInterval,
                oddInterval: oddInterval,
                evenInterval: evenInterval,
                bigOddInterval: bigOddInterval,
                bigEvenInterval: bigEvenInterval,
                smallOddInterval: smallOddInterval,
                smallEvenInterval: smallEvenInterval
            })
    
        }
    }
}
</script>